import { render, staticRenderFns } from "./CompetencesItem.vue?vue&type=template&id=66590436&"
import script from "./CompetencesItem.vue?vue&type=script&lang=js&"
export * from "./CompetencesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports